import '../../globals.css';
import React from 'react';
import { ConfigProvider, Layout } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { TopNav } from '../TopNav/TopNav';
import { SiteFooter } from '../SiteFooter/SiteFooter';

export interface ILayoutProps { children: React.ReactNode; }

export const LayoutWrapper = ({ children }: ILayoutProps) => (
  <ConfigProvider theme={{ token: { colorPrimary: '#00609C', borderRadius: 0, fontFamily: "'Montserrat',Helvetica,Arial,sans-serif" } }}>
    <Layout style={{ minHeight: '100vh' }}>
      <TopNav/>
      <Content>{children}</Content>
      <SiteFooter/>
    </Layout>
  </ConfigProvider>
);
